<template>
  <div>
    <el-row :gutter="15">
      <el-col :span="5">
        <el-card class="card">
          <div slot="header"
               class="card-header"><i class="el-icon-font el-icon-zuzhijigou el-icon--left"></i>部门</div>
          <div style="overflow:auto;height: calc(100vh - 179px);">
            <es-org-tree @clickByOrg="loadLineList"
                         @completed="initOrgTree"></es-org-tree>
          </div>
        </el-card>
      </el-col>
      <el-col :span="19">
        <el-card class="card">
          <div slot="header"
               class="card-header"><i class="el-icon-font el-icon-quyu el-icon--left"></i>线路</div>
          <div class="es-op-box">
            <el-input placeholder="请输入线路名称"
                      v-model="queryObj.name"
                      size="small"
                      class="query"
                      style="float: left"
                      clearable
                      @change="() => { this.queryObj.pageNum = 1; loadLineList(selectorgId) }">
              <i slot="suffix"
                 class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-button type="primary"
                       icon="el-icon-font el-icon-web__tianjia"
                       size="mini"
                       style="margin-right:6px"
                       @click="add_init">新增</el-button>
            <es-delete @del="linedelete()"
                       type="button"></es-delete>
          </div>
          <el-table :data="pageData.list"
                    ref="lineTable"
                    border
                    stripe
                    size="mini"
                    height="calc(100vh - 250px)"
                    v-loading="loading">
            <el-table-column type="selection"
                             width="40"
                             align="center">
            </el-table-column>
            <el-table-column type="index"
                             label="序号"
                             width="50"
                             align="center">
            </el-table-column>
            <el-table-column prop="name"
                             label="线路">
            </el-table-column>
            <el-table-column prop="templateName"
                             label="模版">
            </el-table-column>
            <el-table-column prop="sysName"
                             label="所属系统">
            </el-table-column>
            <el-table-column prop="orgName"
                             label="部门">
            </el-table-column>
            <el-table-column label="操作"
                             width="120"
                             align="center">
              <template slot-scope="scope">
                <el-link :underline="false"
                         title="编辑"
                         @click="edit_init(scope.row)"
                         type="primary"><i class="el-icon-font el-icon-bianji"></i></el-link>
                <el-divider direction="vertical"></el-divider>
                <el-link :underline="false"
                         title="内容编辑"
                         @click="edit_work(scope.row)"
                         type="primary"><i class="el-icon-s-order"></i></el-link>
                <el-divider direction="vertical"></el-divider>
                <es-delete @del="linedelete(scope.row.id)"
                           :key="scope.row.id"
                           type="icon"></es-delete>
              </template>
            </el-table-column>
          </el-table>
          <div class="es-page-box">
            <es-pagination :data="pageData"
                           @change="(cpage) => { this.queryObj.pageNum = cpage; this.loadLineList() }">
            </es-pagination>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <!--编辑线路-->
    <el-dialog :visible.sync="editVisible"
               @closed="() => this.$refs['lineForm'].clearValidate()"
               width="800px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>编辑线路
      </span>
      <el-form :inline="true"
               :model="lineInfo"
               :rules="linerules"
               size="mini"
               label-position="right"
               label-width="150px"
               ref="lineForm">
        <el-form-item prop="name"
                      label="线路">
          <el-input v-model="lineInfo.name"
                    placeholder="请输入线路"
                    style="width:200px"
                    clearable>
          </el-input>
        </el-form-item>
        <el-form-item prop="templateId"
                      label="模版">
          <el-select ref="templateSelect"
                     v-model="lineInfo.templateId"
                     placeholder="请选择模版">
            <el-option v-for="item in templateList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="sysId"
                      label="系统">
          <el-select v-model="lineInfo.sysId"
                     placeholder="请选择所属系统">
            <el-option v-for="item in sysList"
                       :key="item.id"
                       :label="item.name"
                       :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="orgId"
                      label="所属部门">
          <el-cascader ref="orgId"
                       v-model="lineInfo.orgId"
                       :show-all-levels="false"
                       :props="{ value: 'id', checkStrictly: true }"
                       :options="orgTree"
                       filterable
                       style="width:200px"></el-cascader>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button size="mini"
                   @click="editVisible = false">取 消</el-button>
        <el-button type="primary"
                   size="mini"
                   @click="submitLine()"
                   :loading="saving">保 存</el-button>
      </span>
    </el-dialog>
    <!--编辑作业内容-->

    <!--编辑线路作业-->
    <el-dialog :visible.sync="editWorkVisible"
               @closed="() => this.$refs['workForm'].clearValidate()"
               width="1000px">
      <span slot="title">
        <i class="el-icon-font el-icon-bianji el-icon--left"></i>编辑巡检内容
      </span>
      <el-form size="mini"
               label-position="right"
               label-width="150px"
               ref="workForm">
        <div class="es-op-box">
          <el-input placeholder="请输入区域名称"
                    v-model="queryWorkObj.areaName"
                    size="small"
                    class="query"
                    style="float: left"
                    clearable
                    @change="() => { this.queryWorkObj.pageNum = 1; loadworkrulelist() }">
            <i slot="suffix"
               class="el-input__icon el-icon-search"></i>
          </el-input>
          <el-button type="primary"
                     icon="el-icon-font el-icon-web__tianjia"
                     size="mini"
                     style="margin-right:6px"
                     @click="workrule_init">新增</el-button>
          <es-delete @del="workrule_del()"
                     type="button"></es-delete>
        </div>
        <el-table :data="this.workruleData.list"
                  ref="workTable"
                  border
                  highlight-current-row
                  stripe
                  size="mini"
                  height="60vh">

          <el-table-column type="index"
                           label="序号"
                           width="50"
                           align="center">
          </el-table-column>
          <el-table-column type="selection"
                           width="50"
                           align="center">
          </el-table-column>

          <el-table-column prop="name"
                           width="200"
                           label="区域名称">
            <template slot-scope="scope">

              <el-select v-if="scope.row.edit == true"
                         v-model="scope.row.areaId"
                         filterable
                         size="mini"
                         placeholder="区域名称">
                <el-option v-for="item in areaData.list"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id">
                </el-option>
              </el-select>
              <span v-else>{{ scope.row.areaName }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="isArea"
                           width="100"
                           label="是否区域巡检">
            <template slot-scope="scope">
              <el-select v-if="scope.row.edit == true"
                         v-model="scope.row.isArea"
                         size="mini"
                         placeholder="区域是否巡检">
                <el-option v-for="item in isAreas"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id">
                </el-option>
              </el-select>
              <span v-else-if="scope.row.edit == false && scope.row.isArea == 1">是</span>
              <span v-else>否</span>
            </template>
          </el-table-column>

          <el-table-column prop="orderNum"
                           width="120"
                           label="顺序">
            <template slot-scope="scope">
              <el-input-number v-if="scope.row.edit == true"
                               v-model="scope.row.orderNum"
                               style="width:80px"
                               size="small"
                               :min="1"
                               :max=100
                               controls-position="right">
              </el-input-number>
              <span v-else>{{ scope.row.orderNum }}</span>
            </template>
          </el-table-column>

          <el-table-column prop="name"
                           label="巡检设备类型">
            <template slot-scope="scope">
              <el-select v-if="scope.row.isArea == 0 && scope.row.edit == true"
                         v-model="scope.row.types"
                         size="mini"
                         style="width:100%"
                         filterable
                         border:
                         none
                         multiple
                         placeholder="设备类型">
                <el-option v-for="item in types"
                           :key="item.id"
                           :label="item.name"
                           :value="item.id">
                </el-option>
              </el-select>
              <span v-else-if="scope.row.isArea == 0 && scope.row.edit == false">{{ scope.row.typesName }}</span>
            </template>
          </el-table-column>

          <el-table-column label="操作"
                           width="80"
                           align="center">
            <template slot-scope="scope">
              <el-link v-if="scope.row.edit == false"
                       :underline="false"
                       title="编辑"
                       @click="singleWork_edit(scope.row)"
                       type="primary"><i class="el-icon-font el-icon-bianji"></i></el-link>
              <el-link v-if="scope.row.edit == true"
                       :underline="false"
                       title="保存"
                       @click="save_work(scope.row)"
                       type="primary"><i class="el-icon-s-claim"></i></el-link>
              <el-divider direction="vertical"></el-divider>
              <es-delete @del="workrule_del(scope.row.id)"
                         type="icon"
                         :disabled="(scope.row.id != null && scope.row.id != '' ? false : true)"
                         :key="scope.row.id"></es-delete>
            </template>
          </el-table-column>
        </el-table>
        <div class="es-page-box">
          <es-pagination :data="workruleData"
                         @change="(cpage) => { this.queryWorkObj.pageNum = cpage; this.loadworkrulelist() }">
          </es-pagination>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'insline',
  props: ["funcs"],
  data () {
    return {
      orgTree: [],
      sysList: [],
      templateList: [],
      selectorgId: [],
      durationList: [{
        value: 0,
        label: '关闭'
      }, {
        value: 1,
        label: '启用'
      }],
      queryObj: { pageNum: 1, pageSize: 20 },//查询条件
      queryWorkObj: { pageNum: 1, pageSize: 20 },//作业内容查询条件      
      pageData: {},
      editVisible: false,
      lineInfo: {},//线路信息
      linerules: {//验证条件
        name: [
          { required: true, message: '请输入线路', trigger: 'blur' },
          { max: 20, message: '不能超过20个字符', trigger: 'blur' }
        ],
        templateId: [
          { required: true, message: '请输入巡检模版', trigger: 'blur' }

        ],
        orgId: [
          { required: true, message: '请输入部门', trigger: 'blur' }

        ],
        sysId: [
          { required: true, message: '请输入所属系统', trigger: 'blur' }

        ],
      },

      editWorkVisible: false,
      areaInfo: {},//区域信息
      types: [],
      isAreas: [{ "id": 0, name: "否" }, { "id": 1, name: "是" }],

      areaData: [],
      workruleData: [],//巡检区域规则    
      workinfo: {},//作业信息
      SelectworkRow: {},

      loading: false,
      saving: false,
    }
  },
  methods: {
    //页面初始化
    init () {
      this.loadLineList()
      this.initsys()
      this.initdeviceType()
      this.inittemplate()
    },
    //从后台查询线路列表
    loadLineList (orgIds) {
      this.selectorgId = orgIds
      if (orgIds != null && orgIds != []) {
        this.queryObj.orgIds = orgIds.join(',')
      }
      this.loading = true
      this.$ajax.get('/buss/line/linelist', this.queryObj).then(msg => {
        this.pageData = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })

    },
    initOrgTree (orgTree) {
      this.orgTree = orgTree
    },

    initsys () {
      this.loading = true
      this.$ajax.get('/base/system/listAll',).then(msg => {
        this.sysList = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },

    inittemplate () {
      this.$ajax.get('/buss/instemplate/list_all',).then(msg => {
        this.templateList = msg
      }).catch(err => {
        this.$message.error(err)
      })
    },
    //初始化添加线路
    add_init () {
      this.lineInfo = {}
      this.editVisible = true
    },
    //初始化线路
    edit_init (row) {
      this.editVisible = true
      this.lineInfo = JSON.parse(JSON.stringify(row))
    },
    //保存线路
    submitLine () {
      this.$refs["lineForm"].validate(valid => {
        if (valid) {
          let url = "/buss/line/lineadd";
          if (this.lineInfo.id != null) {
            url = "/buss/line/lineedit";
          }
          for (var s of this.sysList) {
            if (s.id == this.lineInfo.sysId) {
              this.lineInfo.sysName = s.name
              break
            }
          }
          this.lineInfo.orgId = this.$refs.orgId.getCheckedNodes()[0].value
          this.lineInfo.orgName = this.$refs.orgId.getCheckedNodes()[0].label
          this.lineInfo.templateName = this.$refs.templateSelect.selected.label
          this.saving = true
          this.$ajax.post(url, this.lineInfo).then(msg => {
            this.saving = false
            this.loadLineList()
            this.editVisible = false
            this.$message.success(msg)
          }).catch(err => {
            this.$message.error(err)
            this.saving = false
          })
        }
      })
    },
    //删除线路
    linedelete (delId) {
      let ids = []
      if (delId != null) {
        ids = [delId]
      } else {
        this.$refs["lineTable"].selection.forEach((ele) => {
          ids.push(ele.id)
        })
      }
      if (ids.length > 0) {
        this.loading = true
        this.$ajax.post('/buss/line/linedelete', { 'ids': ids }).then(msg => {
          this.loading = false
          this.$message.success(msg)
          this.queryObj.pageNum = 1//删除之后，回到第一页
          this.loadLineList()
        }).catch(err => {
          this.$message.error(err)
          this.loading = false
        })
      }
    },



    //*****作业规则使用功能****
    loadAreaDataList () {
      let queryArea = { pageNum: 1, pageSize: 2000 }
      queryArea.orgIds = this.lineInfo.orgId
      this.loading = true
      this.$ajax.get('/base/area/list', queryArea).then(msg => {
        this.areaData = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },

    initdeviceType () {
      this.$ajax.get('/base/assettype/list_all',).then(msg => {
        this.types = msg
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },

    loadworkrulelist () {
      this.queryWorkObj.lineId = this.lineInfo.id
      this.loading = true
      this.$ajax.get('/buss/line/workrulelist', this.queryWorkObj).then(msg => {
        this.workruleData = msg
        for (var i = 0; i < this.workruleData.list.length; i++) {
          if (this.workruleData.list[i].types != null && this.workruleData.list[i].types != '') {
            this.workruleData.list[i].types = this.turnNum(this.workruleData.list[i].types.split(";"))
          }
          this.$set(this.workruleData.list[i], 'edit', false)
        }
        this.loading = false
      }).catch(err => {
        this.$message.error(err)
        this.loading = false
      })
    },

    workrule_init () {
      let newrow = { "id": null, "areaId": null, "orderNum": 1, "isArea": 1, "types": [], "edit": true }
      this.workruleData.list.push(newrow)
    },
    edit_work (row) {
      this.queryWorkObj.pageNum = 1
      this.lineInfo = row
      this.loadAreaDataList()
      this.loadworkrulelist()
      this.editWorkVisible = true
    },

    singleWork_edit (row) {
      row.edit = true
    },

    save_work (row) {
      this.SelectworkRow = row;
      this.workinfo = JSON.parse(JSON.stringify(row))
      this.workinfo.lineId = this.lineInfo.id
      this.workinfo.lineName = this.lineInfo.name
      for (var i = 0; i < this.areaData.list.length; i++) {
        if (this.areaData.list[i].id == this.workinfo.areaId) {
          this.workinfo.areaTypeId = this.areaData.list[i].type
          this.workinfo.areaTypeName = this.areaData.list[i].typename
          this.workinfo.areaCode = this.areaData.list[i].code
          this.workinfo.areaName = this.areaData.list[i].name
          row.areaName = this.workinfo.areaName
        }
      }

      if (row.isArea == 1) {
        this.workinfo.types = null
        row.types = null
      }
      else {
        if (row.types == null || row.types.length == 0) {
          this.$message.error("设备类型不能为空")
          return
        }
      }
      this.workinfo.typesName = null
      if (this.workinfo.types != null) {
        for (var m = 0; m < this.types.length; m++) {
          for (var n = 0; n < this.workinfo.types.length; n++) {
            if (this.types[m].id == this.workinfo.types[n]) {
              if (this.workinfo.typesName == null) {
                this.workinfo.typesName = this.types[m].name
              }
              else {
                this.workinfo.typesName = this.workinfo.typesName + ";" + this.types[m].name
              }
              break;
            }
          }
        }
      }

      if (this.workinfo.typesName != null) {
        row.typesName = this.workinfo.typesName
      }
      else {
        row.typesName = null
      }

      if (row.types != null && row.types != "" && row.types.length > 0) {
        this.workinfo.types = row.types.join(';')
      }
      else {
        this.workinfo.types = null
      }
      console.log(this.workinfo)
      let url = "/buss/line/workruleadd";
      if (this.workinfo.id != null) {
        url = "/buss/line/workruleedit";
      }
      for (var s of this.sysList) {
        if (s.id == this.lineInfo.sysId) {
          this.lineInfo.sysName = s.name
          break
        }
      }
      this.saving = true
      this.$ajax.post(url, this.workinfo).then(msg => {
        this.saving = false
        this.editVisible = false
        if (this.workinfo.id == null) {
          var msglist = msg.split("-");
          if (msglist.length == 2) {
            this.SelectworkRow.id = parseInt(msglist[1])
          }
          this.$message.success(msglist[0])
        }
        else {
          this.$message.success(msg)
        }
        row.edit = false
      }).catch(err => {
        this.$message.error(err)
        this.saving = false
      })
    },

    //删除作业内容
    workrule_del (delId) {
      let ids = []
      if (delId != null) {
        ids = [delId]
      } else {
        this.$refs["workTable"].selection.forEach((ele) => {
          ids.push(ele.id)
        })
      }
      if (ids.length > 0) {
        this.loading = true
        this.$ajax.post('/buss/line/workruledelete', { 'ids': ids }).then(msg => {
          this.loading = false
          this.$message.success(msg)
          this.queryObj.pageNum = 1//删除之后，回到第一页
          this.loadworkrulelist()
        }).catch(err => {
          this.$message.error(err)
          this.loading = false
        })
      }
    },

    turnNum (nums) {
      for (let i = 0; i < nums.length; i++) {
        nums[i] = parseInt(nums[i])
      }
      return nums;
    },
  },
  mounted () {
    this.init()
  }
}
</script>
<style scoped></style>
